import React, { ReactElement, ReactNode } from 'react';

import { Layout } from 'shared/components/layout/Layout';

interface Props {
  children: ReactNode;
}

function LayoutPupDocs(props: Props): ReactElement {
  const { children } = props;

  return <Layout>{children}</Layout>;
}

export default LayoutPupDocs;
